module.exports = __webpack_public_path__ + "static/media/verticalBooking.9ae72b72.ico";